module.exports = __webpack_public_path__ + "img/uc.a851c3be.svg";